module.exports = __webpack_public_path__ + "img/menu-waterQuality.6fbaa0df.png";